import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "theme-uicore"
    }}>{`@theme-ui/core`}</h1>
    <p>{`Core Emotion and JSX implementation for Theme UI`}</p>
    <p><a parentName="p" {...{
        "href": "https://theme-ui.com"
      }}>{`https://theme-ui.com`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/core
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`This package is already included in the main `}<inlineCode parentName="p">{`theme-ui`}</inlineCode>{` package. However, for a minimal installation, it's possible to install this standalone and then subsequently install only the packages you require.`}</p>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`jsx`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Context`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`useThemeUI`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`merge`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`ThemeProvider`}</inlineCode></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      